/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;

      $( '.product-quantity button.subtract, .product-quantity button.add' ).on( 'click', function() {
        const thisProductQuantity = $( this ).closest( 'tr' ).find( '.product-quantity' );
        const quantity = $( thisProductQuantity ).find( 'input' ).val();

        let newQuantity = 0;

        if ( $( this ).hasClass( 'subtract' ) ) {
          newQuantity = parseInt( quantity, 10 ) - 1;
        } else if ( $( this ).hasClass( 'add' ) ) {
          newQuantity = parseInt( quantity, 10 ) + 1;
        }

        if ( newQuantity > -1 && !$( thisProductQuantity ).find( 'input' ).is( ':disabled' ) ) {
          $( thisProductQuantity ).find( 'input' ).val( newQuantity ).trigger( 'change' );
        }
      } );

      $( '.product-add-to-cart' ).on( 'click', function() {
        const quantity = $( this ).closest( 'tr' ).find( '.product-quantity input' ).val();
        addProductToCart( $( this ).attr( 'data-product-id' ), quantity );
        $( this ).closest( 'tr' ).find( '.product-quantity input' ).val( 0 );
      } );

      function addProductToCart( productId, quantity ) {
        const data = {
          'product_id': productId,
          'quantity': quantity,
        };

        $.ajax( {
          type: 'GET',
          url: siteInfo.wpApiSettings.ll + 'shop/addProductToCart',
          data: data,
          beforeSend: function( xhr ) {
            xhr.setRequestHeader( 'X-WP-Nonce', siteInfo.wpApiSettings.nonce );
            xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
            doingAjax = true;
          },
          success: function( data ) {
            console.log( data );

            $( '.custom-wc-notification__wrapper' ).append( data.notification ).addClass( 'is-active' );
            $( '.navbar .cart-num' ).text( data.cart_total_items );

            setTimeout( function() {
              $( '.custom-wc-notification__wrapper' ).removeClass( 'is-active' );
            }, 5000 );

            setTimeout( function() {
              $( '.custom-wc-notification' ).remove();
            }, 6000 );
          },
          complete: function( jqXHR, status ) {
            doingAjax = false;
          },
        } );
      }

      if ( $( '.custom-wc-notification__wrapper' ).hasClass( 'is-active' ) ) {
        setTimeout( function() {
          $( '.custom-wc-notification__wrapper' ).removeClass( 'is-active' );
        }, 5000 );

        setTimeout( function() {
          $( '.custom-wc-notification' ).remove();
        }, 6000 );
      }
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'shop', COMPONENT );
} )( app );
